import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {selectInstance} from '../store/data/orders';
import {DEFAULT_KEY, OrdersMgrInstance} from 'coreClasses/order/OrdersMgr';

/**
 * useOrdersMgr custom hook
 */
export default function useOrdersMgr(key: string = DEFAULT_KEY): OrdersMgrInstance {
	const {managerRepository} = useGeneralProvider();

	const instance = useSelector((state) => selectInstance(state, key));

	return useVersioned(managerRepository.getOrdersMgr().getInstance(key), instance);
};
